export const EventTypes = {
  MENU_ITEM_CLICKED: 'menu_item_clicked',
  LOADING: "loading",
  LOADED: "loaded",
  BAG_VIDEO_LOADED: "bag_video_loaded",
  BAG_VIDEO_LOADING: "bag_video_loading",
  VIDEO_BOUNDING_BOX_CHANGE: "video_bounding_box_change",
  PHONE_ROTATED: "phone_rotated",
  VIDEO_LOAD_PROGRESS: "video_load_progress"
}
